/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RecentCommentHistoryConfig_formValues = {
    readonly recentCommentHistory: {
        readonly enabled: boolean;
        readonly timeFrame: number;
        readonly triggerRejectionRate: number;
    };
    readonly " $refType": "RecentCommentHistoryConfig_formValues";
};
export type RecentCommentHistoryConfig_formValues$data = RecentCommentHistoryConfig_formValues;
export type RecentCommentHistoryConfig_formValues$key = {
    readonly " $data"?: RecentCommentHistoryConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"RecentCommentHistoryConfig_formValues">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecentCommentHistoryConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "RecentCommentHistoryConfiguration",
            "kind": "LinkedField",
            "name": "recentCommentHistory",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeFrame",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "triggerRejectionRate",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '013ef3c7a0a3f8ce46e5e4bf7d5ec016';
export default node;
